import { useEffect, useState } from 'react';

import { EnumService } from '../service';
import { EnumAutocomplete } from '../type';

const enumCache = {} as Record<string, EnumAutocomplete[]>;

export const useEnumValues = (enumClassName, baseUrl = '/api') => {
  const [options, setOptions] = useState<EnumAutocomplete[]>([]);

  useEffect(() => {
    if (enumCache[enumClassName]) {
      setOptions(enumCache[enumClassName]);
      return;
    }
    EnumService.getEnumValues(baseUrl, enumClassName).then(({ data }) => {
      enumCache[enumClassName] = data;
      setOptions(data);
    });
  }, [enumClassName, baseUrl]);

  return options;
};
